import isFeatureToggleOn from "@javascripts/utils/feature_toggle";

export default class VideoDom {
  constructor({ data, autoplay } = {}) {
    this._data = data;
    this._autoplay = autoplay;
  }

  data() {
    return this._data;
  }

  autoplay() {
    return this._autoplay;
  }

  render() {
    const tracks = this.getTracks();

    return `
      <video
        id="${this.data().playerId()}"
        class="video-js vjs-default-skin"
        tabindex='-1'
        style="opacity: 0"
        playsinline
        controls="true"
        crossorigin="anonymous"
        ${ this.autoplay().value() ? 'autoplay' : '' }
        ${ this.data().mute() ? 'muted' : '' }>
        ${ isFeatureToggleOn('enable_subtitle_from_master_playlist')? '' : tracks }
      </video>
    `;
  }

  getSubtitles() {
    const subtitles = JSON.parse(this.data().subtitles()) || [];

    return subtitles.filter((subtitle) => {
      return subtitle.language !== null
    });
  }

  getTracks() {
    return this.getSubtitles().map(({ language, file }) => {
      const isIndonesian = language.toLowerCase() === 'indonesian';
      const label = this.formatLabel(language);

      return `<track kind="captions" src="${file.url}" label="${label}"${ isIndonesian ? ' default' : '' } />`;
    });
  }

  formatLabel(string) {
    return string[0].toUpperCase() + string.slice(1);
  }
}
